<template>
  <div class="imgText" :class="{exer:isExer}">
    <!--练习册-->
    <div class="exerType" v-if="exerType==1">
      <el-row class="lay" type="flex" :gutter="20">
        <el-col
        :key="i"
        :span="4"
        v-for="(item,i) in exerData">
          <div class="con lib">
            <div class="img" @click="selExerShow(item)">
              <img :src="item.CoverImg" alt="">
            </div>
            <div v-if="item.DeleteFlag == 1" class="img deleted">
              <label>已删除</label>
            </div>
            <div class="title">
              <el-row>
                <el-col :span="24" style="height: 2.4rem;line-height: 1.2rem;overflow: hidden;">
                  <span>{{item.Name}}</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <p>出版社: {{item.PublishingHouse}}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="16">
                  <p>作者: {{item.Author}}</p>

                </el-col>
								<el-col :span="8" class="btns">
								  <i v-if="item.isCollect"
								     @click="unCollect(item)"
                     title="取消收藏"
                     class="el-icon-star-on"></i>
								  <i v-else
								     @click="collect(item)"
                     title="添加收藏"
								     class="el-icon-star-off"></i>
                  <i v-if="userId == item.AddUserId && selScopeLevel !== 2"
                     @click="deleteBook(i)"
                     :title="selScopeLevel == '0' ? '删除记录' : '删除'"
                     class="el-icon-delete"></i>
								</el-col>
              </el-row>

            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--练习册分页-->
    <el-pagination
    v-if="exerType==1"
    @current-change="exerPageChange"
    :current-page.sync="exerPage.currentPage"
    :page-size="exerPage.pageSize"
    :pager-count="exerPage.pageCounter"
    layout="prev, pager, next,jumper"
    :total="exerPage.total">
    </el-pagination>
    <!--练习页-->
    <div class="exerType" v-if="exerType==2">
      <!--练习页开始-->
      <el-row :gutter="20" type="flex" class="lay">
        <el-col
          :span="4"
          :key="i"
          v-for="(item,i) in pagesData.datalist">
          <div class="con">
            <div class="img page" @click="selPagesPage(item,!item.chk)">
              <img :src="item.PageImg" alt="">
<!--              <div v-if="item.issue" class="issue">-->
<!--                <el-tooltip effect="dark" content="已下达过作业" placement="right-end">-->
<!--                  <i class="el-icon-circle-check"></i>-->
<!--                </el-tooltip>-->
<!--              </div>-->
            </div>
            <h5 class="title">
              <el-row>
                <el-col :offset="1" :span="2">
                  <span>
                    <el-checkbox
                    v-model="item.chk"
                    @change="selPagesPage(item,$event)"></el-checkbox>
                  </span>
                </el-col>
                <el-col :offset="2" :span="18">
                  <div class="pageTitle">
                    第{{item.PageNo}}页
                  </div>
                </el-col>
<!--                <el-col :span="2" class="btns">-->
<!--                  <i class="el-icon-delete"-->
<!--                     @click=""></i>-->
<!--                </el-col>-->
              </el-row>
            </h5>
          </div>
        </el-col>
<!--        <el-col :sm="6" :md="6" :lg="4">-->
<!--          <div class="con">-->
<!--            &lt;!&ndash;如果是练习库,则不显示添加.&ndash;&gt;-->
<!--            <div class="img">-->
<!--              <el-upload-->
<!--                class="avatar-uploader"-->
<!--                action="https://jsonplaceholder.typicode.com/posts/"-->
<!--                :show-file-list="false"-->
<!--                :on-success="handleAvatarSuccess"-->
<!--                :before-upload="beforeAvatarUpload">-->
<!--                <img v-if="imageUrl" :src="imageUrl" class="avatar">-->
<!--                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
<!--              </el-upload>-->
<!--            </div>-->
<!--            <h5 class="title title2">-->
<!--              添加练习页-->
<!--            </h5>-->
<!--          </div>-->
<!--        </el-col>-->
      </el-row>
      <!--练习页结束-->
    </div>
    <!--练习页分页.-->
    <el-pagination
			v-if="exerType==2"
			@current-change="pagesPageChange"
			:current-page.sync="pagesPage.currentPage"
			:page-size="pagesPage.pageSize"
			:pager-count="pagesPage.pageCounter"
			layout="prev, pager, next,jumper"
			:total="pagesPage.total">
    </el-pagination>

    <!--练习册编辑对话框开始-->
<!--    <el-dialog
      width="500px"
      :title="`${isExerEdit?'编辑':'添加'}练习册`"
      :visible.sync="exerFormDialog">
      <el-form :model="exerFormData">
        <el-form-item label="练习册名称">
          <el-input
            placeholder="请输入练习册名称"
            v-model="exerFormData.name"></el-input>
        </el-form-item>
        <el-form-item label="练习册封面"><br>
          <el-row :gutter="30">
            <el-col :span="10">
              <div class="con conCover">
                <div class="img">
                  <i v-if="!exerFormData.exerUrl" class="el-icon-plus"></i>
                  <img v-else :src="exerFormData.exerUrl" alt="">
                </div>
              </div>
            </el-col>
            <el-col :span="14">
              <div class="coverInfo">
                <p>图片大小不超过2M</p>
                <p> 支持jpg、jpeg、gif、png格式</p>
                <p>（不选择封面，则使用默认图片）</p>
                <el-upload
                  class="upload-demo"
                  action="#">
                  <el-button size="small" type="primary">添加封面</el-button>
                </el-upload>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="练习册尺寸">
          <el-input placeholder="请输入长度"
                    v-model="exerFormData.long">
            <template slot="prepend">长度:</template>
            <el-button slot="append">厘米</el-button>
          </el-input>
          <el-input
            style="margin-top: 10px;"
            placeholder="请输入宽度"
            v-model="exerFormData.width">
            <template slot="prepend">宽度:</template>
            <el-button slot="append">厘米</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="exerFormDialog = false">保 存</el-button>
        <el-button @click="exerFormDialog = false">取 消</el-button>
      </div>
    </el-dialog>-->
    <!--练习册编辑对话框结束-->

  </div>
</template>

<script>
  //import * as api from "../../api/workImgText"
  export default {
    name: "imgText",
    props: {
      //1,练习册,2练习页,3练习库
      exerType: {
        type: [String, Number],
        default() {
          return 1
        }
      },
      //全部、最近使用、我的收藏、我的练习册、全网资源、本校资源
      selScopeLevel: {
        type: [Number],
        default() {
          return 0
        }
      },
      // 练习册数据(收藏,个人上传,都归于这里,这个类别是固定的)
      exerData: {
        type: Array,
        default() {
          return []
        }
      },
      exerPage:{
        type:Object,
        default(){
          return {
            currentPage: 0,
            pageSize: 12,//每页个数
            total: 100,//总个数
            pageCounter: 11,//页码数
          }
        }
      },
      // 练习页数据,
      pagesData: {
        type: Object,
        default() {
          return {}
        }
      },
      pagesPage:{
        type:Object,
        default(){
          return {
            currentPage: 1,
            pageSize: 6,//每页多少行
            total: 100,//总行数
            pageCounter: 11,//折叠数,只能为单数....神奇啊
          }
        }
      },
    },
    data() {
      return {
        userId: 0,
        /*// 当前编辑的练习册属性数据开始
        exerFormData: {
          title: ''
        },
        exerFormDialog: false,//是否显示练习册编辑对话框
        isExerEdit: false,*/
        // 练习册属性数据结束

        // 练习页属性数据开始
        isExer: false, //是否是有分类的练习页
        // 练习页属性数据结束


        //练习册题库开始
        searchText: '',
        //练习册题库结束

        // 添加练习页,在练习库时要消失.
        imageUrl:'',
      }
    },
    watch: {},
    created() {
      this.userId = localStorage.getItem('UserID');
      console.log(localStorage.getItem('UserID'));
      // // 有分类的练习页/
      let tp = this.$route.params.exerType;
      if (tp) {
        this.isExer = true;
      }
    },
    methods: {
      //分页返回搜索
      exerPageChange(e){
        this.$emit("exer-page-change",e);
      },
      pagesPageChange(e){
        this.$emit("pages-page-change",e);
      },
      //收藏练习册,写死了
      collect(item){
        console.log(item);
        this.axios.post(window.hosturl + '/rest/ExerciseBook/SaveCollect', {exerciseBookId:item.Id})
        .then(
          res=>{
            console.log(res);
            if (res.data.result !== 200) {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
              return;
            }
            item.isCollect=!item.isCollect;
            this.$message({
              showClose: true,
              message: '收藏成功',
              type: 'success'
            });
          }
        )
      },
      //取消练习册收藏, 写死了
      unCollect(item){
        console.log(item);
        this.axios.post(window.hosturl + '/rest/ExerciseBook/DeleteCollect', {exerciseBookId:item.Id})
          .then(
            res=>{
              console.log(res);
              if (res.data.result !== 200) {
                this.$message({
                  message: res.data.message,
                  type: 'error'
                });
                return;
              }
              item.isCollect=!item.isCollect;
              this.$message({
                showClose: true,
                message: '取消收藏成功',
                type: 'success'
              });
            }
          )
      },
      deleteBook(i) {
        if (this.selScopeLevel == 1) {
          //删除使用记录
          this.$confirm('此操作将永久删除使用记录，是否继续？','提示',{
            confirmButtonText:'确定',
            cancelButtonText:'取消',
            type:'warning'
          }).then(() => {
            this.axios.post(window.hosturl + '/rest/ExerciseBook/DeleteExerciseBookUserLog', {bookId:this.exerData[i].Id})
                .then(
                    res=>{
                      if (res.data.result !== 200) {
                        this.$message({
                          message: res.data.message,
                          type: 'error'
                        });
                        return;
                      }
                      this.$emit("delete-book", i);
                      this.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success'
                      });
                    }
                );
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          //删除练习册
          this.$confirm('此操作将永久删除此教辅资料，是否继续？','提示',{
            confirmButtonText:'确定',
            cancelButtonText:'取消',
            type:'warning'
          }).then(() => {
            this.axios.post(window.hosturl + '/rest/ExerciseBook/DeleteExerciseBook', {bookId:this.exerData[i].Id})
                .then(
                    res=>{
                      if (res.data.result !== 200) {
                        this.$message({
                          message: res.data.message,
                          type: 'error'
                        });
                        return;
                      }
                      this.$emit("delete-book", i);
                      this.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success'
                      });
                    }
                );
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //选择练习册.
      selExerShow(item){
       this.$emit("sel-exer-show",item)
      },
      //选择练习页
      selPagesPage(item,checked){
        console.log(item,checked);
        this.$emit("sel-page",{item,checked})
      },
      /*// 添加练习册
      exerAdd() {
        this.exerFormDialog = true;
        this.isExerEdit = false
      },
      //编辑练习册
      exerEdit(item) {
        console.log(item);
        this.exerFormDialog = true;
        this.isExerEdit = true;

      },*/
      //删除练习册
      exerDel(item) {
        console.log(item);
        this.$confirm(`此操作将永久删除${item}, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

        }).catch(() => {

        });
      },
      /*练习册封面点击进入练习页,目前(册,库共用)
      * */
      exerImg() {
        this.$router.push({name: 'ImgText', params: {exerType: 2}})
      },

      //添加新作业,跳转到, 裁剪页)
      jumpExerCut() {
        this.$router.push({name: 'ExerCut'})
      },
      // 加入到新作业
      upImg() {

      }
    }
  }
</script>

<style scoped lang="less">
  .imgText {
    position: relative;
    background: #fff;
    padding-bottom: 30px;
    &.exer {
      padding: 1.25rem;
      margin-top: 1.25rem;
    }
    .el-row.lay {
      flex-wrap: wrap;
      .el-col {
        /*float: none;*/
      }
    }
    .con {
			width: 100%;
			height: 0;
			padding-bottom: 190%;
      position: relative;
      .img {
				position: relative;
				height: 0;
				padding-bottom: 138%;
				/* padding: 0.9375rem; */
				border: 1px solid #e5e5e5;
				overflow: hidden;
				cursor: pointer;
				
        /deep/ div {
          height: 100%;
          width: 100%;
        }
        img {
          width: 100%;
        }
        .el-icon-plus {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 3.125rem;
          color: #D8D8D8;
        }
        &:hover {
          .el-icon-plus {
            color: #666666;
          }
        }
        //已经下发过作业的div
        .issue {
          position: absolute;
          background: rgba(0, 0, 0, .3);
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          font-size: 26px;
          color: #63AC53;

          text-align: center;
          i {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            /*background: #63AC53;*/
            background: #fff;
            padding: 6px;
            border-radius: 100px;
          }
        }
      }
      .deleted {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        text-align: center;
        color: #fff;
        background: #00000077;
        z-index: 10000;
        cursor: initial;
        label {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          right: 0;
          width: 56px;
          height: 56px;
          line-height: 54px;
          text-align: center;
          border: 1px solid;
          border-radius: 28px;
        }
      }
      .title {
        margin-top: 0.625rem;
        font-size: 0.75rem;
        font-weight: 600;
        .btns {
          text-align: right;
          i {
            margin-left: 0.1875rem;
            cursor: pointer;
          }
        }
        .pageTitle {
          text-align: right;
        }
      }
      /*添加的标题*/
      .title2 {
        margin-top: 0.625rem;
        text-align: center;
        font-weight: normal;
        font-size: 1rem;
      }
      //
      &.conCover {
        .img {
          height: 190px;
        }
      }
      &.lib {
        .title {
          font-weight: 600;
          .btns {
            .el-icon-star-on {
              font-size: 15px;
              color: #f56816;
            }
          }
          p {
            font-weight: normal;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            /* &:first-child {
              margin-top: 10px;
            } */

          }
        }
      }
    }
    .coverInfo {
      padding: 10px 0 20px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    //练习册编辑对话框
    /deep/ .el-dialog {
      .el-dialog__header {
        background: #51ACFF;
        text-align: center;
        .el-dialog__title {
          color: #fff;
        }
        i {
          color: #fff;
        }
      }
      .el-dialog__footer {
        text-align: center;
        .el-button {
          padding: 0.625rem 1.875rem;
        }
      }
      .el-form-item__label {
        font-weight: bold;
        color: #000;
      }
    }
    .libList {
      h2 {
        margin: 30px 0 10px;
        font-size: 26px;
      }
    }
    .pageBtns {
      margin-bottom: 20px;
    }
     .exerType{
       /*overflow: hidden;*/
     }
    .el-pagination{
      text-align: center;
      position: absolute;
      bottom:-15px;
      left:50%;
      transform: translateX(-50%);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/exercise/imgText.vue